<template>
    <div class="basic_wrap">
        <!-- 顶部标题栏 -->
        <div class="login_password_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" :alt="$t('invest.DepositRecords')">
            </div>
            <div class="big_tit">{{ $t('user.ChangeLoginPassword') }}</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 输入字段区域 -->
            <div class="input_fields">
                <!-- 原密码 -->
                <div class="input_field">
                    <div class="field_label">{{ $t('user.CurrentPassword') }}</div>
                    <input 
                        type="password" 
                        class="field_input" 
                        :placeholder="$t('user.Pleaseentercurrentpassword')"
                        v-model="originalPassword"
                    >
                </div>

                <!-- 新密码 -->
                <div class="input_field">
                    <div class="field_label">{{ $t('user.NewPassword') }}</div>
                    <input 
                        type="password" 
                        class="field_input" 
                        :placeholder="$t('user.Pleaseenternewpassword')"
                        v-model="newPassword"
                    >
                </div>

                <!-- 确认密码 -->
                <div class="input_field">
                    <div class="field_label">{{ $t('user.ConfirmPassword') }}</div>
                    <input 
                        type="password" 
                        class="field_input" 
                        :placeholder="$t('user.Pleaseconfirmpassword')"
                        v-model="confirmPassword"
                    >
                </div>
            </div>

            <!-- 提交按钮 -->
            <div class="submit_button_container">
                <button class="submit_button" @click="submitPasswordChange">{{ $t('login.submit') }}</button>
            </div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
    name: "LoginPassword",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            originalPassword: '',
            newPassword: '',
            confirmPassword: ''
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
    },
    methods: {
        // 提交密码修改
        async submitPasswordChange() {
            // 验证输入
            if (!this.originalPassword) {
                alert(this.$t('user.Pleaseentercurrentpassword'));
                return;
            }
            if (!this.newPassword) {
                alert(this.$t('user.Pleaseenternewpassword'));
                return;
            }
            if (!this.confirmPassword) {
                alert(this.$t('user.Pleaseconfirmpassword'));
                return;
            }
            if (this.newPassword !== this.confirmPassword) {
                alert(this.$t('user.Newpasswordandconfirmpassworddonotmatch'));
                return;
            }
            
            try {
                console.log('开始修改登录密码...');
                
                // 调用API修改密码
                const result = await Fetch('/index/repasswd', {
                    passwd: this.originalPassword,    // 原密码
                    npasswd: this.newPassword        // 新密码
                });
                
                console.log('修改密码API响应:', result);
                
                if (result && result.code === 1) {
                    console.log('密码修改成功:', result);
                    alert(this.$t('user.PasswordModifySuccess'));
                    
                    // 清空输入框
                    this.originalPassword = '';
                    this.newPassword = '';
                    this.confirmPassword = '';
                    
                    // 可以跳转到其他页面或返回上一页
                    this.$router.go(-1);
                } else if (result && result.code === 0) {
                    console.log('密码修改业务提示:', result);
                    // 显示业务提示信息
                    let message = '';
                    if (typeof result.info === 'string') {
                        message = result.info;
                    } else if (typeof result.info === 'object') {
                        const currentLang = localStorage.getItem('lang') || 'zh_hk';
                        message = result.info[currentLang] || result.info.zh_cn || '密码修改失败';
                    }
                    alert(message);
                } else {
                    console.error('密码修改失败:', result);
                    alert('密码修改失败，请稍后重试');
                }
            } catch (error) {
                console.error('修改密码请求出错:', error);
                alert('网络错误，请稍后重试');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

.login_password_header {
    position: relative;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #000000;
    border-bottom: 1px solid #f0f0f0;

    .back_left {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        cursor: pointer;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.main_content {
    flex: 1;
    background: #ffffff;
    padding: 20px 16px;
}

.input_fields {
    margin-bottom: 40px;
}

.input_field {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }

    .field_label {
        width: 80px;
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        text-align: left;
    }

    .field_input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 16px;
        color: #333333;
        background: transparent;
        text-align: right;
        padding-right: 50px;

        &::placeholder {
            color: #999999;
            font-size: 14px;
        }
    }
}

.submit_button_container {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}

.submit_button {
    width: 100%;
    height: 48px;
    background: #1890ff;
    color: #ffffff;
    border: none;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background: #40a9ff;
    }

    &:active {
        background: #096dd9;
    }
}

/* 底部导航栏样式 */
.footer {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    flex: 0 0 48px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 750px;
    bottom: 0;
    height: 60px;
    z-index: 4;
}

.footer .footer_item {
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    color: #55585a;
    width: 60px;
}

.footer .footer_item .footer_icon {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 6px;
}

.footer .footer_item .footer_icon.footer_icon_home {
    background-image: url(../../../src/assets/images/tab/shou.png);
}

.footer .footer_item .footer_icon.footer_icon_task {
    background-image: url(../../../src/assets/images/tab/item.png);
}

.footer .footer_item .footer_icon.footer_icon_cart {
    background-image: url(../../../src/assets/images/tab/kefu.png);
}

.footer .footer_item .footer_icon.footer_icon_user {
    background-image: url(../../../src/assets/images/tab/my.png);
}

.footer .footer_item .footer_info {
    font-size: 12px;
}

.footer .footer_item.footer_item_active {
    color: #3775f4;
}
</style> 